import {ConfirmArgs, ModalHook, useConfirmModal} from "../../modals";

const title = "Are you sure you want to make this change?";
const body = <>Making this change will delete the content in the post. This action cannot be undone.</>;
export function useConfirmChangeModal<T>(props: Omit<ConfirmArgs<T>, "body" | "title">): ModalHook<T> {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	return useConfirmModal(() => ({title, body, ...props}), [Object.values(props)]);
}
